import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { api } from "@/lib/api";
import { absoluteUrl } from "@/components/PinItButton";
import usePageMeta, { readingTime } from "@/lib/seo";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  usePageMeta({ title: "Journal", description: "Field notes from the coast — product roundups, gear deep-dives, and lifestyle essays from Gulf Coast Home Co." });

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page" className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <header className="mb-16 max-w-2xl">
        <p className="text-xs uppercase tracking-[0.24em] text-[#8EAD9E] mb-3">The Journal</p>
        <h1 className="font-heading text-5xl md:text-6xl text-[#2D3032] font-light tracking-tight">
          Field notes from the coast.
        </h1>
        <p className="mt-6 text-[#636769] leading-relaxed">
          Product roundups, gear deep-dives, and quiet essays on building a home you actually want to come back to.
        </p>
      </header>

      {loading ? (
        <p className="text-[#636769]">Loading…</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p, idx) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className={`group block bg-white border border-[#E6E1D6] gc-card gc-fade ${idx === 0 ? "md:col-span-2 lg:col-span-3" : ""}`}
            >
              <div className="aspect-[16/9] overflow-hidden bg-[#F4F1EA]">
                <img src={absoluteUrl(p.cover_image)} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 gc-sunwash" />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex gap-3 items-center mb-3 text-[10px] uppercase tracking-[0.2em] text-[#8EAD9E]">
                  {p.tags?.slice(0, 1).map((t) => (
                    <span key={t}>#{t}</span>
                  ))}
                  <span className="text-[#E6E1D6]">/</span>
                  <span className="flex items-center gap-1.5 text-[#636769]"><Clock size={11} strokeWidth={1.8} /> {readingTime(p.content)} min</span>
                </div>
                <h2 className={`font-heading font-medium text-[#2D3032] ${idx === 0 ? "text-3xl md:text-4xl" : "text-xl"} leading-tight group-hover:text-[#8EAD9E] transition-colors`}>
                  {p.title}
                </h2>
                <p className="mt-3 text-sm text-[#636769] leading-relaxed line-clamp-2">{p.excerpt}</p>
                <span className="mt-5 inline-block text-xs uppercase tracking-[0.2em] text-[#EBAA86] group-hover:text-[#2D3032]">
                  Read article →
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
